'use client';
import React from 'react';
import { useInitAnalytics, Environment, Region } from '@chewy/use-analytics';
import { PAGE_TYPE_MAIN } from '../shared/util/config';

export const ClientChewyAnalytics = (
  props: React.PropsWithChildren<{ version: string; region: string; environment: string }>,
): React.JSX.Element => {
  const input = {
    appName: 'pet-profile',
    appVersion: props.version,
    environment: (props.environment as Environment) || 'qat',
    region: (props.region as Region) || 'use1',
    pageType: PAGE_TYPE_MAIN,
  } as const;

  //init analytics
  useInitAnalytics(input);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{props.children}</>;
};
